import { Component, OnInit, OnDestroy, Inject, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { EntityService } from '@app/core/services/http-services/model/entity.service';
import { TranslateModule, TranslateService, _ } from '@ngx-translate/core';
import { Button } from '@progress/kendo-angular-buttons';
import { DialogContentBase, DialogRef, KENDO_DIALOG } from '@progress/kendo-angular-dialog';
import { GridDataResult, KENDO_GRID } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { State } from '@progress/kendo-data-query';
import { cancelIcon, saveIcon, SVGIcon } from '@progress/kendo-svg-icons';
import { Subject, takeUntil } from 'rxjs';
import { MarketSelectorComponent } from '@app/features/app-controls/market/market-selector.component';
import { Guid } from 'guid-typescript';
import { FormsModule } from '@angular/forms';
import { IBudgetDetailsRequestDTO } from '@app/core/models/budget-dto.model';
import { EntityGroupService, IEntityGroupDTO } from '@app/core/services/custom-services/entity-group.service';
import { KendoGridHelper } from '@app/shared/helpers/kendo-grid.helper';
import { KendoGridDropDownFilterComponent } from '@app/core/components/kendo-grid-drop-down-filter/kendo-grid-drop-down-filter.component';

_('EntityTranslation.SelectMaterials');

@Component({
  selector: 'app-entity-multiselect',
  templateUrl: './entity-multiselect.component.html',
  styleUrls: ['./entity-multiselect.component.scss'],
  imports: [
    KENDO_GRID,
    KENDO_DIALOG,
    KENDO_SVGICON,
    Button,
    TranslateModule,
    MarketSelectorComponent,
    FormsModule,
    KendoGridDropDownFilterComponent
  ],
})
export class EntityMultiselectComponent extends DialogContentBase implements OnInit, AfterViewInit, OnDestroy {
  gridData: GridDataResult = { data: [], total: 0 };
  selectedMaterialIndexes: number[] = [];
  selectedMarketId: Guid;
  state: State = {
    skip: 0,
    take: null,
    filter: {
      logic: 'and',
      filters: [],
    },
  };
  isMaterialUsed: { key: boolean; text: string }[];
  entityGroups: IEntityGroupDTO[] = [];

  //Icons
  saveIcon: SVGIcon = saveIcon;
  cancelIcon: SVGIcon = cancelIcon;

  private readonly destroy$ = new Subject<void>();

  @ViewChild('content') elementView: ElementRef;

  constructor(
    @Inject(DialogRef)
    public data: { showMarket: boolean; budgetId: Guid; budgetItemId: Guid },
    private readonly entityService: EntityService,
    private readonly entityGroupService: EntityGroupService,
    private readonly translate: TranslateService,
    dialogRef: DialogRef
  ) {
    super(dialogRef);
    this.isMaterialUsed = [
      { key: true, text: this.translate.instant('App.Yes') },
      { key: false, text: this.translate.instant('App.No') },
    ];
  }

  ngOnInit(): void {
    this.getEntityGroups();
  }

 override ngAfterViewInit() {
    this.state.take = KendoGridHelper.calculateSmallGridPageSize(this.elementView.nativeElement.offsetHeight);
     this.loadGrid();
  }

  loadGrid(): void {
    this.entityService
      .listMaterials(this.state, this.data.budgetId, this.data.budgetItemId, true)
      .pipe(takeUntil(this.destroy$))
      .subscribe((entity) => {
        this.gridData = entity;
      });
  }

  dataStateChange(state: State): void {
    this.state = state;
    this.loadGrid();
  }

  save(): void {
    if (this.data.showMarket) {
      const budgetDetailsRequestDTO: IBudgetDetailsRequestDTO = {
        budgetId: Guid.createEmpty(),
        marketId: this.selectedMarketId,
        materialIndex: this.selectedMaterialIndexes,
      };
      this.dialog.close(budgetDetailsRequestDTO);
    } else {
      this.dialog.close(this.selectedMaterialIndexes);
    }
  }

  cancel(): void {
    this.dialog.close();
  }

  private getEntityGroups() {
    //We are using this only at one place for now, if needed we can pass this params as input from the respective component.
    this.entityGroupService.listEntityGroup('RESOURCE', true).subscribe({
      next: (d) => {
        this.entityGroups = d;
      },
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
